import Vue from 'vue'
import VueRouter from 'vue-router'
import loadQuestions from './inc/loadQuestions'
import loadProperties from './inc/loadProperties'

import Home from '@/components/views/home/Home'
import MainLayout from '@/components/layouts/Main'
import Relatorio from '../components/views/relatorio/Relatorio'

const MinhaConta = () => import('@/components/views/minhaConta/MinhaConta')
const Resultado = () => import('@/components/views/resultado/Resultado')
const FaleConosco = () => import('@/components/views/faleConosco/FaleConosco')
const PageNotFound = () => import('@/components/views/pageNotFound/PageNotFound')
const ListData = () => import('@/components/views/listaDados/ListaDados')
const ArvoreObjeto = () => import('@/components/views/arvoreObjeto/ArvoreObjeto')

const Tema = () => import('@/components/tema/Index')

const Usuario = () => import(/* webpackChunkName: "usuarios" */'@/components/views/usuario/Index')
const UsuarioList = () => import(/* webpackChunkName: "usuarios" */'@/components/views/usuario/Usuario')
const UsuarioCreate = () => import(/* webpackChunkName: "usuarios" */'@/components/views/usuario/Create')

const Objeto = () => import(/* webpackChunkName: "objetos" */'@/components/views/objeto/Index')
const ObjetoList = () => import(/* webpackChunkName: "objetos" */'@/components/views/objeto/Objeto')
const ObjetoCreate = () => import(/* webpackChunkName: "objetos" */'@/components/views/objeto/Create')
const ObjetoQuestoes = () => import(/* webpackChunkName: "objetos" */'@/components/views/objeto/Questoes')

const Curadoria = () => import(/* webpackChunkName: "curadoria" */'@/components/views/curadoria/index')
const CuradoriaList = () => import(/* webpackChunkName: "curadoria" */'@/components/views/curadoria/Curadoria')
const CuradoriaCreate = () => import(/* webpackChunkName: "curadoria" */'@/components/views/curadoria/create')

const Tipos = () => import(/* webpackChunkName: "tipos" */'@/components/views/tipos/index')
const TiposList = () => import(/* webpackChunkName: "tipos" */'@/components/views/tipos/Tipos')
const TiposCreate = () => import(/* webpackChunkName: "tipos" */'@/components/views/tipos/create')

const ColecoesList = () => import(/* webpackChunkName: "coleções" */'@/components/views/colecoes/Colecoes')
const ColecaoView = () => import(/* webpackChunkName: "coleções" */'@/components/views/colecoes/Colecao')
const Colecao = () => import(/* webpackChunkName: "coleções" */'@/components/views/colecoes/Index')

const AuthLayout = () => import(/* webpackChunkName: "auth" */'@/components/views/auth/index')
const Login = () => import(/* webpackChunkName: "auth" */'@/components/views/auth/login')
const ForgotPassword = () => import(/* webpackChunkName: "auth" */'@/components/views/auth/forgotPassword')
const RecoverPassword = () => import(/* webpackChunkName: "auth" */'@/components/views/auth/recoverPassword')

const Status = () => import(/* webpackChunkName: "status" */'@/components/views/status/Status')

const Cliente = () => import(/* webpackChunkName: "clientes" */'@/components/views/cliente/Index')
const ClienteList = () => import(/* webpackChunkName: "clientes" */'@/components/views/cliente/Cliente')
const ClienteCreate = () => import(/* webpackChunkName: "clientes" */'@/components/views/cliente/Create')

const Publicacoes = () => import(/* webpackChunkName: "publicacoes" */'@/components/views/publicacao/Index')
const PublicacaoList = () => import(/* webpackChunkName: "publicacoes" */'@/components/views/publicacao/Publicacoes')
const PublicacaoCreate = () => import(/* webpackChunkName: "publicacoes" */'@/components/views/publicacao/Create')

const TiposQuestoes = () => import(/* webpackChunkName: "tiposQuestao" */'@/components/views/tiposQuestao/Index')
const TiposQuestoesList = () => import(/* webpackChunkName: "tiposQuestao" */'@/components/views/tiposQuestao/TiposQuestao')
const TiposQuestoesCreate = () => import(/* webpackChunkName: "tiposQuestao" */'@/components/views/tiposQuestao/Create')

const NivelDificuldade = () => import(/* webpackChunkName: "tiposQuestao" */'@/components/views/nivelDificuldade/Index')
const NivelDificuldadeList = () => import(/* webpackChunkName: "tiposQuestao" */'@/components/views/nivelDificuldade/NivelDificuldade')
const NivelDificuldadeCreate = () => import(/* webpackChunkName: "tiposQuestao" */'@/components/views/nivelDificuldade/Create')

const Questoes = () => import(/* webpackChunkName: "questoes" */'@/components/views/questoes/Index')
const QuestoesList = () => import(/* webpackChunkName: "questoes" */'@/components/views/questoes/Questoes')
const QuestoesCreate = () => import(/* webpackChunkName: "questoes" */'@/components/views/questoes/Create')
const QuestoesHistorico = () => import(/* webpackChunkName: "questoes" */'@/components/views/questoes/Historico')

const ImportacoesObjetos = () => import(/* webpackChunkName: "importacoes" */'@/components/views/importacoes/ImportacoesObjetos')
const ImportacoesQuestoes = () => import(/* webpackChunkName: "importacoes" */'@/components/views/importacoes/ImportacoesQuestoes')

const loggedRoutes = [
	{
		path: '/',
		meta: { auth: [1, 2, 3, 4, 6], breadCrumb: 'Home' },
		name: 'home',
		component: Home
	},
	{
		path: '/usuarios',
		component: Usuario,
		children: [
			{ path: '', name: 'usuariosList', component: UsuarioList, meta: { auth: [1, 2, 3, 4], redirect: { name: 'login' }, breadCrumb: 'Usuários' } },
			{ path: 'create', name: 'usuarioCreate', component: UsuarioCreate, meta: { auth: [1, 2, 3, 4], redirect: { name: 'login' }, breadCrumb: 'Usuários|Cadastrar' } },
			{ path: ':id', name: 'usuarioEdit', component: UsuarioCreate, meta: { auth: [1, 2, 3, 4, 6], redirect: { name: 'login' }, breadCrumb: 'Usuários|Editar' } }
		]
	},
	{
		path: '/objetos',
		meta: { auth: [1, 2, 3, 6], redirect: { name: 'login' } },
		component: Objeto,
		children: [
			{ path: 'importacoes', name: 'importacoesObjetos', component: ImportacoesObjetos, meta: { auth: [1, 2, 3], redirect: { name: 'login' }, breadCrumb: 'Objetos|Importações' } },
			{ path: '', name: 'objetoList', component: ObjetoList, meta: { breadCrumb: 'Objetos' } },
			{ path: 'create', name: 'objetoCreate', component: ObjetoCreate, meta: { auth: [1, 2, 3, 8], redirect: { name: 'login' }, breadCrumb: 'Objetos|Cadastrar' } },
			{ path: ':id', name: 'objetoEdit', component: ObjetoCreate, meta: { auth: [1, 2, 3, 8], redirect: { name: 'login' }, breadCrumb: 'Objetos|Editar' } },
			{ path: 'detalhes/:id', name: 'objetoDetalhes', component: ObjetoCreate, meta: { auth: [1, 2, 3, 6], redirect: { name: 'login' }, readOnly: true, breadCrumb: 'Objetos|Detalhes' } },
			{ path: 'questoes/historico/:id', name: 'questoesHistorico', component: QuestoesHistorico, meta: { breadCrumb: 'Objetos|Histórico Questões' } },
			{ path: 'questoes/:id', name: 'objetoQuestoes', component: ObjetoQuestoes, meta: { breadCrumb: 'Objetos|Questões' } }
		]
	},
	{
		path: '/curadoria',
		meta: { auth: [1, 2, 3, 6], redirect: { name: 'login' } },
		component: Curadoria,
		children: [
			{ path: '', name: 'curadoriaList', component: CuradoriaList, meta: { breadCrumb: 'Curadorias' } },
			{ path: 'create', name: 'curadoriaCreate', component: CuradoriaCreate, meta: { breadCrumb: 'Curadorias|Cadastrar' } },
			{ path: ':id', name: 'curadoriaEdit', component: CuradoriaCreate, meta: { breadCrumb: 'Curadorias|Editar' } }
		]
	},

	{
		path: '/colecoes',
		meta: { auth: [1, 2, 3], redirect: { name: 'login' } },
		component: Colecao,
		children: [
			{ path: '', name: 'colecoesList', component: ColecoesList, meta: { breadCrumb: 'Coleções produzidas' } },
			{ path: ':id/:botao', name: 'colecaoView', component: ColecaoView, meta: { breadCrumb: 'Coleções produzidas' } }
		]
	},
	{
		path: '/resultados',
		meta: { auth: [1, 2], redirect: { name: 'login' } },
		name: 'resultados',
		component: Resultado
	},
	{
		path: '/tipos',
		meta: { auth: [1], redirect: { name: 'login' } },
		component: Tipos,
		children: [
			{ path: '', name: 'tiposList', component: TiposList, meta: { breadCrumb: 'Tipos de Objeto' } },
			{ path: 'create', name: 'tiposCreate', component: TiposCreate, meta: { breadCrumb: 'Tipos de Objeto|Cadastrar' } },
			{ path: ':id', name: 'tiposEdit', component: TiposCreate, meta: { breadCrumb: 'Tipos de Objeto|Editar' } },
			{ path: 'detalhes/:id', name: 'tiposDetalhes', component: TiposCreate, meta: { auth: [1, 2, 3, 6], redirect: { name: 'login' }, readOnly: true, breadCrumb: 'Tipos de Objeto|Detalhes' } }
		]
	},
	{
		path: '/minhaconta',
		meta: { auth: [1, 2, 3, 4], redirect: { name: 'login' } },
		name: 'minhaConta',
		component: MinhaConta
	},
	{
		path: '/relatorios',
		meta: { auth: [1, 2, 3], redirect: { name: 'login' } },
		component: Relatorio,
		children: [
			{ path: '', name: 'relatorios', component: Relatorio, meta: { breadCrumb: 'Relatórios' } }
		]
	},
	{
		path: '/status',
		meta: { auth: [1, 2, 3], redirect: { name: 'login' } },
		component: Status,
		children: [
			{ path: '', name: 'status', component: Status, meta: { breadCrumb: 'Status da Produção' } }
		]
	},
	{
		path: '/clientes',
		meta: { auth: [1, 2, 3], redirect: { name: 'login' } },
		component: Cliente,
		children: [
			{ path: '', name: 'clienteList', component: ClienteList, meta: { breadCrumb: 'Clientes' } },
			{ path: 'create', name: 'clienteCreate', component: ClienteCreate, meta: { breadCrumb: 'Clientes|Cadastrar' } },
			{ path: ':id', name: 'clienteEdit', component: ClienteCreate, meta: { breadCrumb: 'Clientes|Editar' } }
		]
	},
	{
		path: '/publicacoes',
		meta: { auth: [1], redirect: { name: 'login' } },
		component: Publicacoes,
		children: [
			{ path: '', name: 'publicacaoList', component: PublicacaoList, meta: { breadCrumb: 'Publicações' } },
			{ path: 'create', name: 'publicacaoCreate', component: PublicacaoCreate, meta: { breadCrumb: 'Publicações|Cadastrar' } }
		]
	},
	{
		path: '/nivelDificuldade',
		meta: { auth: [1], redirect: { name: 'login' } },
		component: NivelDificuldade,
		children: [
			{ path: '', name: 'nivelDificuldadeList', component: NivelDificuldadeList, meta: { breadCrumb: 'Nível dificuldade' } },
			{ path: 'create', name: 'nivelDificuldadeCreate', component: NivelDificuldadeCreate, meta: { breadCrumb: 'Nível dificuldade|Cadastrar' } },
			{ path: ':id', name: 'nivelDificuldadeEdit', component: NivelDificuldadeCreate, meta: { breadCrumb: 'Nível dificuldade|Editar' } }
		]
	},
	{
		path: '/tiposQuestao',
		meta: { auth: [1], redirect: { name: 'login' } },
		component: TiposQuestoes,
		children: [
			{ path: '', name: 'tiposQuestoesList', component: TiposQuestoesList, meta: { breadCrumb: 'Tipos de Questões' } },
			{ path: 'create', name: 'tiposQuestoesCreate', component: TiposQuestoesCreate, meta: { breadCrumb: 'Tipos de Questões|Cadastrar' } },
			{ path: ':id', name: 'tiposQuestoesEdit', component: TiposQuestoesCreate, meta: { breadCrumb: 'Tipos de Questões|Editar' } }
		]
	},
	{
		path: '/questoes',
		meta: { auth: [1, 2, 3, 6], redirect: { name: 'login' } },
		component: Questoes,
		children: [
			{ path: '', name: 'questoesList', component: QuestoesList, meta: { breadCrumb: 'Questões' } },
			{ path: 'importacoes', name: 'ImportacoesQuestoes', component: ImportacoesQuestoes, meta: { breadCrumb: 'Questões|Importações' } },
			{ path: 'create', name: 'questoesCreate', component: QuestoesCreate, meta: { breadCrumb: 'Questões|Cadastrar' } },
			{ path: ':id', name: 'questoesEdit', component: QuestoesCreate, meta: { breadCrumb: 'Questões|Editar' } },
			{ path: ':id/view', name: 'questoesDetails', component: QuestoesCreate, meta: { breadCrumb: 'Questões|Detalhes' } }
		]
	},
	{
		path: '/listdata',
		meta: { auth: [1, 2, 3, 6], redirect: { name: 'login' }, breadCrumb: 'Curadores e Produção' },
		name: 'listData',
		component: ListData,
		children: [
			{ path: 'listdata', name: 'listdata', component: ListData, meta: { breadCrumb: 'Curadores e Produção' } }
		]
	},
	{
		path: '/arvoreObjeto',
		meta: { auth: [1, 2, 3, 6], redirect: { name: 'login' }, breadCrumb: 'Árvore dos Objetos' },
		name: 'arvoreObjeto',
		component: ArvoreObjeto,
		children: [
			{ path: 'arvoreObjeto', name: 'arvoreObjeto', component: ArvoreObjeto, meta: { breadCrumb: 'Árvore dos Objetos' } }
		]
	}
]

const routes = [
	{
		path: '/',
		component: MainLayout,
		children: loggedRoutes
	},
	{
		path: '/tema',
		name: 'tema',
		component: Tema
	},
	{
		path: '/login',
		component: AuthLayout,
		children: [
			{ path: '', name: 'login', component: Login },
			{ path: 'forgot-password', name: 'forgotPassword', component: ForgotPassword },
			{ path: 'recover-password/:id', name: 'recoverPassword', component: RecoverPassword }
		]
	},
	{ path: '/faleconosco', name: 'faleConosco', component: FaleConosco },
	{ path: '*', component: PageNotFound }
]

Vue.use(VueRouter)

const router = new VueRouter({
	routes,
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) return savedPosition
		else return { x: 0, y: 0 }
	},
	linkActiveClass: 'active',
	linkExactActiveClass: 'exact-active',
	mode: 'history'
})

router.beforeEach((to, from, next) => {
	loadQuestions(to, from)
	loadProperties(to, from)
	next()
})
export default router
